import React, { useState } from 'react';
import { config } from '../../config';
import '../../App.css';
import { useTranslation } from '../../i18n';

const AGE_GATE_KEY = `${config.storagePrefix}-age-verified`;

export function isPartyAgeVerified(): boolean {
  try {
    return localStorage.getItem(AGE_GATE_KEY) === 'true';
  } catch {
    return false;
  }
}

function setPartyAgeVerified(): void {
  try {
    localStorage.setItem(AGE_GATE_KEY, 'true');
  } catch {
    // ignore storage failures
  }
}

interface PartyAgeGateProps {
  onVerified: () => void;
  onDecline: () => void;
}

const PartyAgeGate: React.FC<PartyAgeGateProps> = ({ onVerified, onDecline }) => {
  const [declined, setDeclined] = useState(false);
  const { t } = useTranslation();

  if (declined) {
    return (
      <div className="app" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <div style={{ maxWidth: '420px', textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>{t('lobby.partyAgeGate.declinedTitle')}</h1>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', lineHeight: 1.5 }}>
            {t('lobby.partyAgeGate.declinedDescription')}
          </p>
          <a href="https://toyo.games" className="button" style={{ display: 'inline-block', textDecoration: 'none' }}>
            {t('lobby.partyAgeGate.goToToyoGames')}
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="app" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div style={{ maxWidth: '440px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.75rem', marginBottom: '0.75rem' }}>{t('lobby.partyAgeGate.title')}</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', lineHeight: 1.6 }}>
          {t('lobby.partyAgeGate.description')}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <button
            type="button"
            className="button"
            onClick={() => {
              setPartyAgeVerified();
              onVerified();
            }}
          >
            {t('lobby.partyAgeGate.confirm')}
          </button>
          <button type="button" className="button" onClick={() => setDeclined(true)} style={{ opacity: 0.85 }}>
            {t('lobby.partyAgeGate.decline')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PartyAgeGate;
